var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-tags-input',{staticClass:"tags-keywords",attrs:{"tags":_vm.tags,"placeholder":'Add keyword',"allow-edit-tags":true},on:{"tags-changed":function($event){return _vm.addTag($event)}},model:{value:(_vm.tagTxt),callback:function ($$v) {_vm.tagTxt=$$v},expression:"tagTxt"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }